<template>
	<div>
		<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/company/technology_big.png" style="width: 100%;" />
		<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/company/technology_big1.png" style="width: 100%;" />
		<br /><br /><br /><br /><br /><br /><br /><br />
		<div style="width: 90%;" class="center_sun">
			<h2>
				{{ $t('lang.technology1')}}
			</h2>
			<div slot="header" class="clearfix black1" style="text-align: left;">
				<p class="indent" style="text-align: justify;">
				{{ $t('lang.technology2')}}
				</p>
			</div>
			<img  src="../../../public/pic/company/technology.png" style="width: 35%;margin-right: 5%;"/>
			<img  src="../../../public/pic/company/technology1.png" style="width: 60%;"/>
			<img  src="../../../public/pic/company/technology7.png" style="width: 30%;margin-right: 5%;"/>
			<img  src="../../../public/pic/company/technology8.png" style="width: 30%;margin-right: 5%"/>
			<img  src="../../../public/pic/company/technology9.png" style="width: 30%;"/>
			<hr />
			<h2>
				{{ $t('lang.technology19')}}
			</h2>
			<img  src="../../../public/pic/company/technology10.png" style="width: 55%;margin-right: 5%;"/>
			<img  src="../../../public/pic/company/technology11.png" style="width: 40%;"/>
			<hr />
			<h2>
				{{ $t('lang.technology3')}}
			</h2>
			<ul class="ultransverse">
				<li class="litransverse">
					<div class="clearfix black1" style="text-align: left;">
						<span class="indent" style="text-align: justify;">
						{{ $t('lang.technology4')}}<br /><br /><br /><br />
						{{ $t('lang.technology5')}}<br /><br /><br /><br />
						{{ $t('lang.technology6')}}<br /><br /><br /><br />
						{{ $t('lang.technology7')}}<br /><br /><br /><br />
						{{ $t('lang.technology8')}}<br /><br /><br /><br />
						{{ $t('lang.technology9')}}<br /><br />
						</span>
					</div>
				</li>
				<li class="litransverse">
					<img src="../../../public/pic/company/technology2.png" style="width: 80%;vertical-align: bottom"/>
				</li>
			</ul>
			<hr />
			<h2>{{ $t('lang.technology10')}}</h2>
			<ul class="ultransverse">
				<li class="litransverse" >
					<div class="clearfix black1" style="text-align: left;">
						<span class="indent" style="text-align: justify;">
						{{ $t('lang.technology11')}}<br /><br /><br />
						{{ $t('lang.technology12')}}<br /><br /><br />
						{{ $t('lang.technology13')}}<br /><br /><br />
						{{ $t('lang.technology14')}}<br /><br /><br />
						{{ $t('lang.technology15')}}<br /><br /><br />
						{{ $t('lang.technology16')}}<br /><br /><br />
						</span>
					</div>
				</li>
				<li class="litransverse">
					<img src="../../../public/pic/company/technology3.png" style="width: 80%;vertical-align: bottom"/>
				</li>
			</ul>
			<hr />
			<h2>{{ $t('lang.technology17')}}</h2><br />
			<img src="../../../public/pic/company/technology4.png" /><br /><br /><br />
			<img src="../../../public/pic/company/technology5.png" />
			<hr />
			<h2>
				{{ $t('lang.technology20')}}
			</h2>
			<img  src="../../../public/pic/company/technology12.png"/>
			<hr />
			<h2>{{ $t('lang.technology18')}}</h2>
			<img src="../../../public/pic/company/technology6.png" />
			<br /><br /><br /><br />
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '公司简介_深圳全智能机器人科技有限公司  。Company Profile- Shenzhen All Intelligent Technology Co., Ltd.',
			keywords : '消毒机器人,迎宾机器人，陪护机器人,送餐机器人,硅胶实体娃娃,深圳全智能机器人科技有限公司----。Disinfect robots, welcome robots, companion love robots, meal delivery robots, silicone solid dolls, Shenzhen All Intelligent Technology Co., Ltd.',
			description : '全智能科技（AI-Tech）是深圳全智能机器人科技有限公司[Shenzhen All Intelligent Technology Co.，Ltd. ]的简称，沿革于2013年，创建于2016年8月18日。顾名思义，全智能科技（AI-Tech）是以研发、生产、销售人工智能技术服务和产品的国家级高新技术企业。我们利用自主开发的核心技术，以“虚实结合、软硬兼备”的模式，致力于打造实用型的新型人工智能技术和AI科技共享平台。 AI-Tech short for Shenzhen All Intelligent Technology Co.，Ltd. started in 2013 which is a national level high tech company researching, manufacturing, selling AI services and AI products. We leverage self-developed core technologies,combine services with products,software with hardware, dedicating to creat a sharable platform of new pratical AI technology.',
			};
	},
}
</script>

<style scoped>
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}
</style>
